export default __webpack_public_path__ + "static/media/ic_arrow_right.min.4c1d5424.svg";